import { Box, Typography } from "@mui/material";
import PdfViewer from "../Common/PdfViewer";

// Helper function to check if URL is a PDF
function isPdfUrl(url: string): boolean {
    if (!url || typeof url !== "string") return false;
    const lowerUrl = url.toLowerCase();
    return lowerUrl.endsWith(".pdf") || lowerUrl.includes(".pdf?") || lowerUrl.includes("/pdf/");
}

const FormPreview = ({ formDetails }) => {
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid #e0e0e0",
                }}
            >
                {formDetails && formDetails?.length > 0 && formDetails.map((form) => (
                    <Box key={form.formName} sx={{ mb: 1 }}>
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            textAlign="center"
                            sx={{
                                padding: "6px",
                                borderBottom: "1px solid #e0e0e0",
                                wordBreak: "break-word"
                            }}
                        >
                            {form.formName}
                        </Typography>

                        {Object.entries(form.formFields).map(([key, value]) => {
                            const isPdf = typeof value === "string" && value.startsWith("http") && isPdfUrl(value);

                            return (
                                typeof value === "string" && value.startsWith("http") ? (
                                    <>
                                        <Typography
                                            variant="body2"
                                            p={1}
                                            fontWeight="bold"
                                            textTransform="uppercase"
                                            fontSize="12px"
                                            sx={{ wordBreak: "break-word", minWidth: "fit-content" }}
                                        >
                                            {key.replace("_Image", " ")}:
                                        </Typography>
                                        {isPdf ? (
                                            <PdfViewer pdfUrl={value} />
                                        ) : (
                                            <Box
                                                sx={{
                                                    cursor: "pointer",
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <img
                                                    src={value}
                                                    alt="img"
                                                    style={{
                                                        width: "70%",
                                                        height: "70%",
                                                        objectFit: "contain",
                                                        display: "block"
                                                    }}
                                                />
                                            </Box>
                                        )}
                                    </>
                                ) : (
                                    <Box
                                        key={key}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "5px",
                                            borderBottom: "1px solid #e0e0e0",
                                            p: 1
                                        }}
                                    >
                                        <Typography
                                            display="flex"
                                            variant="body2"
                                            fontWeight="bold"
                                            textTransform="uppercase"
                                            fontSize="12px"
                                            sx={{ wordBreak: "break-word" }}
                                        >
                                            {key} :
                                        </Typography>
                                        <Box pl={1} fontSize="13px" color={"gray"}>
                                            {value === null ? "N/A" : String(value) || "-"}
                                        </Box>
                                    </Box>
                                )
                            );
                        })}
                    </Box>
                ))}
                {formDetails?.length <= 0 && <Typography textAlign={"center"} p={2}>No details captured during event.</Typography>}
            </Box>
        </>
    )
}

export default FormPreview;
